<template>
  <div class="mini-grid">
    <div>
      <el-button type="primary" @click="printpage()">打印</el-button>
      <!-- <el-button type="success" @click="start_page()">上一页</el-button>
      <el-button type="success" @click="end_page()">下一页</el-button> -->
      <el-button type="danger" @click="close()">关闭</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "print_yjftzd",
  data() {
    return {
      DJBH:new URLSearchParams(window.location.search).get('DJBH'),
      NY:new URLSearchParams(window.location.search).get('NY'),
      user:JSON.parse(sessionStorage.currentUser)
    };
  },
  methods: {
    close(){
        window.close();
    },
    printpage(){//打印
      let printStr = "<html><head><meta http-equiv='Content-Type' content='text/html;charset=utf-8'></head><body >";
      let content = "";
      let sprnstr = "<!--startprint1-->";//设置打印开始区域
      let eprnstr = "<!--endprint1-->";//设置打印结束区域
      content = content+sprnstr ;//加载打印头

      //纵向：@page { size: portrait; }
      //横向：@page { size: landscape; }
      let sss= "<style"+" type="+"text/css"+">"+"@page { size: auto;margin-top: 5mm;margin-left: 10mm;}"+"body{ zoom:70%;padding: 0px 32px; }"+"</style>" ;
      content+=sss;
      if($("#ipt_count").val()==0){
          $("#ipt_count").val(1);
      }
      let num=$("#ipt_count").val();//打印的页数
      //判断是否只有1页要打印
      if(num==1){
          //只打印一页，是否打印子表
          if( $("#div_box").val()==0 ){
              content+=document.getElementById('model0').innerHTML;
              //let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              //content+=str;
              content+=document.getElementById('model2').innerHTML;
          }else{
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              content+=document.getElementById('model2').innerHTML;
          }

      }else{//不止要打印一份
          for (let i=0;i<num;i++){
              content+=document.getElementById('model0').innerHTML;
              let str = document.getElementById('div_model'+i).innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              if( (i+1)%2==0 ){
                  content+=document.getElementById('model3').innerHTML;
              }else{
                  content+=document.getElementById('model2').innerHTML;
                  content+="<div"+" style='width:100%;height:150px;'"+"></div>";//加空格
              }

          }
      }

      content = content + eprnstr;//加载打印尾
      printStr = printStr+content+"</body></html>";
      let pwin=window.open("Print.htm","print"); //如果是本地测试，需要先新建Print.htm，如果是在域中使用，则不需要
      pwin.document.write(content);
      pwin.document.close();                   //这句很重要，没有就无法实现
      pwin.print();
      window.location.reload();
    },
    start_page(){//上一页
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在上一页");
          return;
      }
      if( $("#ipt").val() == 0 ){
          alert("当前页已经是最前一页");
          return;
      }else{
          $("#ipt").val(  $("#ipt").val()-1  );
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("div_model"+page_number ).style.display="";//显示
          page_number++;
          document.getElementById("div_model"+page_number ).style.display="none";//隐藏
      }
    },
    end_page(){//下一页
      let num=$("#ipt_count").val();
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在下一页");
          return;
      }
      //如果显示的是model0
      if( $("#ipt").val() == num-1 ){
          alert("当前页已经是最后一页");
          return;
      }else{
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("div_model"+page_number ).style.display="none";//隐藏
          page_number++;
          $("#ipt").val(page_number);
          document.getElementById("div_model"+page_number ).style.display="";//显示
      }
    },
    showDJ(data){//展示单据
        //定义一个数组来存储子表数据
        var  son_list=new Array();
        var  count = 0;
        console.log(data);
        var sss="";
            if(data.WBF==null || data.WBF==""){
                data.WBF = 0;
            }
            if(data.HYFWF==null || data.HYFWF==""){
                data.HYFWF = 0;
            }
            sss+="<br/<br/><h2 style='font-size:24px;font-weight: 600;text-align: center;'>"+data.NY1+"&nbsp;&nbsp;预 交 费 通 知 单</h2><br/<br/>"+
            "<table"+"   id=tab_0"+" width=100%"+" style='border-collapse:collapse;'"+">"+
                "<tr>"+
                "</tr>"+
                "</table>";

            sss+="<table"+"   id=tab_0"+" width=100%"+" style='border-collapse:collapse;'"+">"+
                "<tr>"+
                "<td "+" style='text-align:right;font-size:15px;'"+"   colspan=8"+" align='right'"+"><b>"+"单位:元&nbsp;&nbsp;&nbsp;&nbsp;"+"</b></td>"+
                "</tr>"+
                "</table>";

            sss+="<table"+"   id=tab_1"+" width=100%"+"  style='border-collapse:collapse;font-size: 9pt;'"+">"+
                "<tr>"+
                "<td"+" align='right' id=td1"+">"+"合同编号"+"</td>"+
                "<td"+" align='center'"+">"+data.HTH+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"商户名称"+"</td>"+
                "<td"+" align='center'"+">"+data.SHMC+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"品牌"+"</td>"+
                "<td"+" align='center'"+">"+data.JYPP+"</td>"+
                "</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"建筑面积m²"+"</td>";
                if(Number(data.JZMJ) && Number(data.JZMJ)!=0){
                    sss+= "<td"+" align='center'"+">"+data.JZMJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"保底租金"+"</td>";

                if(Number(data.BDZJ) && Number(data.BDZJ)!=0){
                    sss+= "<td"+" align='center'"+">"+data.BDZJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"物业管理费"+"</td>";
                
                if(Number(data.WYGLF) && Number(data.WYGLF)!=0){
                    sss+= "<td"+" align='center'"+">"+data.WYGLF+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"品牌推广费"+"</td>";
                if(Number(data.XCTGF) && Number(data.XCTGF)!=0){
                    sss+= "<td"+" align='center'"+">"+data.XCTGF+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"仓库租赁费"+"</td>";
                if(Number(data.CKZJ) && Number(data.CKZJ)!=0){
                    sss+= "<td"+" align='center'"+">"+data.CKZJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>";
                if(data.FDBH==202){
                   sss +="<td"+" align='right'id=td1"+">"+"推广使用费"+"</td>";     
                }else{
                    sss +="<td"+" align='right'id=td1"+">"+"外摆费"+"</td>";
                }
                if(Number(data.WBF) && Number(data.WBF)!=0){
                    sss+= "<td"+" align='center'"+">"+data.WBF+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"收银系统使用费"+"</td>";
                if(Number(data.SYXTF) && Number(data.SYXTF)!=0){
                    sss+= "<td"+" align='center'"+">"+data.SYXTF+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>";
                if(data.FDBH==202){
                    sss+= "<td"+" align='right'id=td1"+">"+"会员维护费"+"</td>";
                }else{
                    sss+= "<td"+" align='right'id=td1"+">"+"会员促销服务费"+"</td>";
                }
                if(Number(data.HYFWF) && Number(data.HYFWF)!=0){
                    sss+= "<td"+" align='center'"+">"+data.HYFWF+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"其他"+"</td>";
                if(Number(data.QTFY) && Number(data.QTFY)!=0){
                    sss+= "<td"+" align='center'"+">"+data.QTFY+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id=td1"+">"+"应交款合计"+"</td>";
                if(Number(data.KKHJ) && Number(data.KKHJ)!=0){
                    sss+= "<td"+" align='center'"+">"+data.KKHJ+"</td>";
                }else{
                    sss+= "<td"+" align='center'"+">-</td>";
                }
                sss +="</tr>"+
                "<tr>"+
                "<td"+" align='right'id='td1'"+">" 
                if(data.FDBH==201){
                    if(data.LC=='L2' || data.LC=='L3'){
                        sss+='<img  src="/fvue/img/seal.png" width="150px" height="40px"/>'+
                        "单位名称：深圳市海雅缤纷城商业有限公司<br/>开户银行：农业银行深圳南山支行<br/> 账号：41014100040018824<br/>（务必注意转款信息准确性）</td><br/>";
                    }else{
                        sss+='<img  src="/fvue/img/seal.png" width="150px" height="40px"/>'+
                        "单位名称：深圳市海雅缤纷城商业有限公司<br/>开户银行：中国建设银行深圳宝安支行<br/> 账号：44201538900052528985<br/>（务必注意转款信息准确性）</td><br/>";
                    }
                }
                if(data.FDBH==202){
                    sss+="备注</td>";
                }
                sss+="<td"+" align='center'"+">"+data.BZ+"</td>"+
                "</tr>";
                if(data.FDBH==202){
                    sss+="<tr>"+
                    "<td"+" align='right'id='td1'"+">"+"收款账户信息"+"</td>"+
                    "<td"+" align='center'"+">户名：中山市海雅缤纷天地商业有限公司<br/>开户行：中国建设银行南头支行<br/>账号：44050178060100001770</td>"+
                    "</tr>";
                }
                sss+="<tr>"+
                "<td"+" align='right'id='td1'"+">"+"财务对账电话"+"</td>"+
                "<td"+" align='center'"+">"+data.DZLH+"</td>"+
                "</tr>";
            $("#model0").append(sss);

            //子表表头
            var sss2= "<table"+" id=tab_3_"+i+" width=100%"+" style='border-collapse:collapse;font-size: 15px;'"+">";

            var count=1;//子表共有几页
            //console.log(count);
            //设置 计数div 的value 为 count
            $("#ipt_count").val(count);
            $("#div_box").val(data.length);
            for (var i=0;i<count;i++){
                if(i==0){
                    var div_box="<div"+" id="+"div_model"+i+"></div>";
                    $("#model1").append(div_box);
                }else{
                    var div_box="<div"+" id="+"div_model"+i+" style='display:none;'"+"></div>";
                    $("#model1").append(div_box);
                }

            }

            //不带分页的表格尾部
            if(true){
                var sss4=
                    "<table"+" id=tab_5"+" width=100%"+" style='border-collapse:collapse;'"+">"+
                    "<tr>"+
                    "<td"+" align=right"+" style='font-size:15px;'"+" colspan="+"><b>"+"上传时间："+"</b></td>"+
                    "<td"+" style='font-size:15px;'"+" colspan=2"+"><b>"+data.CONFIRM_DATE+"</b></td>";
                    if(data.FDBH==202){
                        sss4+="<td align='right' style='font-size:15px;'  colspan=7><b>中山市海雅缤纷天地商业有限公司</b></td>"+
                        "<td style='font-size:15px;' colspan=2><img  src='/fvue/img/seal_zs.png' width='150px' height='40px'/></td>";
                    }
                    sss4+="</tr>";
                    // "<tr>"+
                    // "<td"+" align='right'"+" style='font-size:15px;'"+"  colspan=7"+"><b>"+"盖章/按手印："+"</b></td>"+
                    // "<td"+">"+""+"</td>"+
                    // "</tr>"+
                    // "<tr>"+
                    // "<td"+" align='right'"+" style='font-size:15px;'"+"  colspan=7"+"><b>"+"日期："+"</b></td>"+
                    // "<td"+">"+""+"</td>"+
                    // "</tr>"+
                    "</table>"
            }
            //带分页的表格尾部
            var div5="<div"+" class="+"table_"+"  id=model5"+" name="+"model"+"></div>";
            var div6="<div"+" class="+"table_"+"  id=model6"+" name="+"model"+"></div>";
            $("#model2").append(div5);
            $("#model3").append(div6);
            $("#model5").append(sss4);
            $("#tab_0  td").css("width","120px");
            $("#tab_1  td").css("width","240px");
            $("#td1").css("width","50%");
            $("#tab_1  td").css("height","25px");
            $("#tab_1 td").css("border","1px solid");
            $("#tab_2  td").css("width","140px");
            $("#tab_2  td").css("height","25px");
            $("#tab_2 td").css("border","1px solid");
            $("#tab_3 td").css("border","1px solid");
            $("#tab_3_1 td").css("border","1px solid");
            $("#tab_4 td").css("border","1px solid");
            $("#tab_5  td").css("width","140px");
            $("#tab_5  td").css("height","25px");
            $("td").css("font-size","16px");
    },
    changeMoneyToChinese(money){
      let cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
      let cnIntRadice = new Array("","拾","佰","仟"); //基本单位
      let cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
      let cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字

      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr=""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      if( money === "" ){
          return "";
      }
      money = parseFloat(money);
      if( money >= maxNum ){
          $.alert('超出最大处理数字');
          return "";
      }
      if( money==0 ){
          ChineseStr = cnNums[0]+cnIntLast+cnInteger;
          return ChineseStr;
      }
      money = money.toString(); //转换为字符串
      if( money.indexOf(".") == -1 ){
          IntegerNum = money;
          DecimalNum = '';
      }else{
          parts = money.split(".");
          IntegerNum = parts[0];
          DecimalNum = parts[1].substr(0,4);
      }
      if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
          let zeroCount = 0;
          let IntLen = IntegerNum.length;
          for(let i=0;i<IntLen;i++ ){
              let n = IntegerNum.substr(i,1);
              let p = IntLen - i - 1;
              let q = p / 4;
              let m = p % 4;
              if( n == "0" ){
                  zeroCount++;
              }else{
                  if( zeroCount > 0 ){
                      ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
              }
              if( m==0 && zeroCount<4 ){
                  ChineseStr += cnIntUnits[q];
              }
          }
          ChineseStr += cnIntLast;
          //整型部分处理完毕
      }
      if( DecimalNum!= '' ){//小数部分
          let decLen = DecimalNum.length;
          for(let i=0; i<decLen; i++ ){
              let n = DecimalNum.substr(i,1);
              if( n != '0' ){
                  ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
              }
          }
      }
      if( ChineseStr == '' ){
          //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
          ChineseStr += cnNums[0]+cnIntLast;
      }
      if( money.substring(money.length-2,money.length-1)===0   ){
          ChineseStr+='整';
      }
      return ChineseStr;
    }
  },
  mounted(){
    let sql="SELECT a.*,substr(a.NY,0,4)||'年'||substr(a.NY,5,6)||'月' as NY1 FROM HT_YJ_TZD a  "+
        "WHERE a.ny='"+this.NY+"' and a.hth='"+this.DJBH+"'";
    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
                for(let i=0;i<resp.data.result.length;i++){
                let ipt="<input type="+"hidden"+" id="+"ipt"+" value="+"0"+">";    //这个input输入框也要隐藏，他的  value 代表是第几页（0代表第一页，默认为0）
                let ipt_count="<input"+" id=ipt_count"+" value="+"0"+" type="+"hidden"+">";//需要隐藏的input ,这个 input 的value是 代表费用子表的记录页数
                let div_hidden="<div"+" id=model_hidden"+"></div>";//需要隐藏的div
                let div_box="<div"+" id="+"div_box"+" value="+"0"+"></div>"; //子表记录条数
                $(".mini-grid").append(ipt);
                $(".mini-grid").append(ipt_count);
                $(".mini-grid").append(div_hidden);
                $(".mini-grid").append(div_box);
                //获取页面跳转时传递的参数
                //开票确认单也要分页
                //默认显示第一页
                let div1="<div"+" class="+"preview"+"  id=model0"+" name="+"model"+"></div>";  //存放页面头
                let div2="<div"+" class="+"preview"+"  id=model1"+" name="+"model"+"></div>";  //存放子表
                let div3="<div"+" class="+"preview"+"  id=model2"+" name="+"model"+"></div>";  //存放页面尾
                let div4="<div"+" class="+"preview"+"  id=model3"+" name="+"model"+" style='display: none;'"+"></div>";  //存放  带有分页标识的表格 (默认隐藏)
                $(".mini-grid").append(div1);
                $(".mini-grid").append(div2);
                $(".mini-grid").append(div3);
                $(".mini-grid").append(div4);
                this.showDJ(resp.data.result[i]);
            }
        }
    })
    let sql_1 = "update HT_YJ_TZD set confirm='"+this.user.account+"',confirm_date=to_char(sysdate,'YYYY-MM-DD HH24:MI:SS') "+
                "where ny="+this.NY+" and hth="+this.DJBH+" and confirm_date is null";
    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql_1)).then(resp=>{

    })
  }
};
</script>

<style lang="scss" scoped>
</style>